<template>
	<div>
		<div style="text-align: left;">
			<el-button size="small" type="primary" icon="el-icon-plus" @click="addParam">新增</el-button>
		</div>
		<div class="comStyle">
			 <el-table :header-cell-style="{background:'#eee',color:'#606266'}"
			    :data="tableData"
				@selection-change="handleSelectionChange"
				:row-class-name="tableRowClassName"
				size="mini"
			    style="width: 100%">
				<el-table-column
				        type="selection"
				        width="55">
				</el-table-column>
			    
			    <el-table-column
			      label="ID" width="50px"
			      prop="id">
			    </el-table-column>
			    <el-table-column
			      label="指标名称" width="150px"
			      prop="mingCh">
			    </el-table-column>
			    <el-table-column 
			      label="key"
			      prop="key">
			    </el-table-column>	
				<el-table-column
				  label="单位"
				  prop="unit">
				</el-table-column>
				<el-table-column 
				  label="监测方法" 
				  prop="jianCFF">
				</el-table-column>
				<el-table-column
				  label="来源" 
				  prop="laiY" >
				</el-table-column>
				<el-table-column
				  label="下限"
				  prop="biaoZhMin" >
				</el-table-column>
				<el-table-column
				  label="开启下限"
				  prop="haveMin" :formatter="formatBoolean"
				  :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column
				  label="上限"
				  prop="biaoZhMax" >
				</el-table-column>
				<el-table-column
				  label="开启上限"
				  prop="haveMax" :formatter="formatBoolean"
				  :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column
				  label="类型"
				  prop="sn">
				</el-table-column>
				<el-table-column
				  label="报表算法"
				  prop="suanF">
				</el-table-column>
				<el-table-column
				  label="小数位"
				  prop="radix">
				</el-table-column>
				<el-table-column
				  label="开启小数位"
				  prop="haveRadix" :formatter="formatBoolean"
				  :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column
				  label="排序"
				  prop="paiXu">
				</el-table-column>
			  </el-table>			  
			  <el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					v-show="play"
					:current-page="currentPage"
					:page-sizes="[10, 20, 30, 40]"
					:page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="totalD">
			  </el-pagination>
			  
			</div>
			<div style="text-align: left;">
				<el-button size="small" type="danger" icon="el-icon-check" @click="updateParam"
				:disabled="multipleSelection.length==0">编辑</el-button>
				<el-button size="small" type="danger" icon="el-icon-minus" @click="deleteSite"
				:disabled="multipleSelection.length==0">删除</el-button>
				<!-- <el-button @click="drawer = true" type="primary" style="margin-left: 16px;">
				  点我打开
				</el-button> -->
			</div>
			
					     
			  
			
			<el-drawer
			  :title="namelg"
			  :visible.sync="dialogVisible"
			  direction="rtl"
			  :before-close="handleClose" 
			  size="50%"
			  >
			  
			  <el-form :rules="rules" inline
				  ref='updatePos' label-position="left" 
				  :model="updatePos" class="comDia" size="mini" >
				  <el-row class="row-param">
				  <el-col :span="12">
				  <el-form-item label="ID" >
				  <el-input class="updatePosInput-param" size="small" v-model="updatePos.id" 
				  :disabled="true" ></el-input>
				  </el-form-item>
				  </el-col>
				  <el-col :span="12">
				  <el-form-item label="key" prop="key">
				  <el-input autofocus="off" class="updatePosInput-param" size="small" v-model="updatePos.key"></el-input>
				  </el-form-item>
				  </el-col>
				  </el-row >
				  <el-row class="row-param">
				  <el-col :span="12" class="row-param">
				  <el-form-item label="指标名称" prop="mingCh">
				  <el-input autofocus="off" class="updatePosInput-param" size="small" v-model="updatePos.mingCh"></el-input>
				  </el-form-item>
				  </el-col>
				  <el-col :span="12">
				  <el-form-item label="单位" prop="unit">
				  <el-input  autofocus="off" class="updatePosInput-param" size="small" v-model="updatePos.unit"></el-input>
				  </el-form-item>
				  </el-col>
				  </el-row>
				  <el-row class="row-param">
					  <el-col :span="12">
				  <el-form-item label="监测方法" prop="jianCFF">
				  <el-input  autofocus="off" class="updatePosInput-param" size="small" v-model="updatePos.jianCFF"></el-input>
				  </el-form-item>				  
				  </el-col>
				  <el-col :span="12">
				  <el-form-item label="来源" prop="laiY">
				  <el-input autofocus="off" class="updatePosInput-param" size="small" v-model="updatePos.laiY"></el-input>
				  </el-form-item>
				  </el-col>
				  </el-row>
				  <el-row class="row-param">
					  <el-col :span="12">
				  <el-form-item label="下限" prop="biaoZhMin">
					  <el-input autofocus="off" class="input-boxp" size="small" v-model="updatePos.biaoZhMin"
					  :disabled="!updatePos.haveMin"></el-input>
					  <el-checkbox v-model="updatePos.haveMin" active-text="是" inactive-text="否"></el-checkbox>
				  </el-form-item>
				  </el-col>
				  <el-col :span="12">
				  <el-form-item label="上限" prop="biaoZhMax">
					  <el-input autofocus="off" class="input-boxp" size="small" v-model="updatePos.biaoZhMax"
					  :disabled="!updatePos.haveMax"></el-input>
					  <el-checkbox v-model="updatePos.haveMax" active-text="是" inactive-text="否"></el-checkbox>
				  </el-form-item>
				  </el-col>
				  </el-row>
				  <el-row class="row-param">
					  <el-col :span="12">
				  <el-form-item label="类型" prop="sn">
					<el-input autofocus="off" class="updatePosInput-param" size="small" v-model="updatePos.sn"></el-input>
				  </el-form-item>
				  </el-col>
				  <el-col :span="12">
				  <el-form-item label="算法" prop="suanF">
				  		<el-input autofocus="off" class="updatePosInput-param" size="small" v-model="updatePos.suanF"></el-input>
				  </el-form-item>
				  </el-col>
				  </el-row>
				  <el-row class="row-param">
					  <el-col :span="12">
				  <el-form-item label="小数位" prop="radix">
				  		<el-input autofocus="off" class="input-boxp" size="small" v-model="updatePos.radix" 
						:disabled="!updatePos.haveRadix"></el-input>
						<el-checkbox v-model="updatePos.haveRadix" active-text="是" inactive-text="否"></el-checkbox>
				  </el-form-item>
				  </el-col>
				  <el-col :span="12">
				  <el-form-item label="排序" prop="paiXu">
				  		<el-input autofocus="off" class="updatePosInput-param" size="small" v-model="updatePos.paiXu"></el-input>
				  </el-form-item>	
				  </el-col>
				  </el-row>
				  
				  <el-form-item>
				  <el-button size="small" @click="dialogVisible = false">取 消</el-button>
				  <el-button size="small" type="primary" @click="doUpdate(updatePos)">确 定</el-button>
				  </el-form-item>
			   </el-form>
			  
			</el-drawer>
			
	</div>
</template>

<script>
	export default {
		name: "SysPara",	
		data() {
		var valifcCycle = (rule, value, callback) => {
			if (this.updatePos.haveForecast == '1') {
				if (value === ''||value === null) {
				    callback(new Error('预警周期不能为空！'));
				}else
				callback();
			}
			else
			callback();
		    
		};
		
		
		
		  return {
			namelg:"更新指标配置",
			
		    tableData: [],
			dialogVisible: false,
			paramVisible:false,
			// showf:true,
			// drawer:false,
			multipleSelection: [],
			
			currentPage:1 ,
			play:true,
			pageSize:10,
			totalD: 0,			
			updatePos: {
				id:null,
				key:null,
				mingCh:null,
				unit:null,
				jianCFF:null,
				laiY:null,
				biaoZhMin:null,
				biaoZhMax:null,
				haveMin:false,
				haveMax:false,
				biaoZhMin0:null,
				biaoZhMax0:null,
				haveMin0:false,
				haveMax0:false,
				sn:null,
				suanF:null,
				radix:null,
				haveRadix:false,
				paiXu:null,

			},
			rules:{
				key: [
					{ required: true,message: 'key不能为空！', trigger: 'blur' }
				],
				mingCh: [
					{ required: true,message: '指标名称不能为空！', trigger: 'blur' }
				],
				suanF: [
					{ required: true,message: '算法不能为空！', trigger: 'blur' }
				],
				sn: [
					{ required: true,message: '类型不能为空！', trigger: 'blur' }
				   /* {validator: validatePass2, trigger: 'blur'} */
				],
				type:  [
					{ required: true, message: '站点类型不能为空！',trigger: 'blur' }
				],
				paramId:[
					{ required: true, message: '指标不能为空！',trigger: 'blur' }
				],
				fcCycle:[
					{validator: valifcCycle, trigger: 'blur'}
				],
				
				
			}
			
		  };
		},
		mounted() {
			this.initLoad();
		},
		methods: {
						
			handleSizeChange(val) {
				
				console.log(`每页 ${val} 条`);
				this.$data.pageSize=val;
				this.initLoad();
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				
				this.$data.currentPage=val;
				this.initLoad();
			},
			
			onforecast(event, item) {     //change 触发事件
			    this.$data.updatePos.forecast= !this.$data.updatePos.forecast      //直接就拿到当前的这个对象
			},
			
			
			handleClose:function(done){
				done();
			},
			formatBoolean: function (row, column, cellValue) {
				var ret = ''  //你想在页面展示的值
				if (cellValue) {
					ret = "是"  //根据自己的需求设定
				} else {
					ret = "否"
				}
				return ret;
			},		
			tableRowClassName({row, rowIndex}) {
				
				if ((rowIndex%2) == 1) {
				  return 'success-row';
				} 
				return '';
			  },
			addParam(){
				this.namelg='保存指标配置'
				this.updatePos.id=null;
				this.updatePos.key=null;
				this.updatePos.mingCh=null;
				this.updatePos.unit=null;
				this.updatePos.jianCFF=null;
				this.updatePos.laiY=null;
				this.updatePos.biaoZhMin=null;
				this.updatePos.biaoZhMax=null;
				this.updatePos.haveMin=false;
				this.updatePos.haveMax=false;
				this.updatePos.biaoZhMin0=null;
				this.updatePos.biaoZhMax0=null;
				this.updatePos.haveMin0=false;
				this.updatePos.haveMax0=false;
				this.updatePos.sn=null;
				this.updatePos.suanF=null;
				this.updatePos.radix=null;
				this.updatePos.haveRadix=false;
				this.updatePos.paiXu=null;
				this.dialogVisible=true;
			
			},
			
			doUpdate(){
				this.$refs.updatePos.validate((valid) => {
					
					console.log(this.updatePos.haveForecast);
					console.log(this.updatePos.dianName);					
					if (valid) {
						if(this.updatePos.id==null){
							this.$confirm('此操作新建一条记录', '提示', {
							        confirmButtonText: '确定',
							        cancelButtonText: '取消',
							        type: 'warning',
							}).then(() => {
							    
								this.updatePos.id=null;
							    this.postRequest("/system/config/sysparam",this.updatePos).then(resp => {
							        if (resp) {
							            this.initLoad();
										//this.paramVisible=false;
										this.dialogVisible=false;
							        }
							    })
							}).catch(() => {
							    this.$message({
							        type: 'info',
							        message: '已取消保存',
									
							    });
								//this.dialogVisible=false;
							});
						}else{
							this.$confirm('此操作修改ID=【' + this.updatePos.id + '】的记录?', '提示', {
							        confirmButtonText: '确定',
							        cancelButtonText: '取消',
							        type: 'warning',
							}).then(() => {
							    
							    this.postRequest("/system/config/sysparam",this.updatePos).then(resp => {
							        if (resp) {
							            this.initLoad();
										this.dialogVisible=false;
							        }
							    })
							}).catch(() => {
								//this.dialogVisible=false;
							    this.$message({
							        type: 'info',
							        message: '已取消修改'
							    });
								
							});
						}
					} else {
						console.log('请输入所有字段！');
						return false;
					}
				})
				
				
			},
			updateParam(){
				if(this.multipleSelection.length!=1){
					this.$message({
					    type: 'warning',
					    message: '请选择单条数据编辑！'
					});
				}else{
					
					this.namelg='更新指标配置'
					this.multipleSelection.forEach(item => {
						this.updatePos.id=item.id
						this.updatePos.key=item.key
						this.updatePos.mingCh=item.mingCh
						this.updatePos.unit=item.unit
						this.updatePos.jianCFF=item.jianCFF
						this.updatePos.laiY=item.laiY
						this.updatePos.biaoZhMin=item.biaoZhMin
						this.updatePos.biaoZhMax=item.biaoZhMax
						this.updatePos.haveMin=item.haveMin
						this.updatePos.haveMax=item.haveMax
						this.updatePos.biaoZhMin0=item.biaoZhMin0
						this.updatePos.biaoZhMax0=item.biaoZhMax0
						this.updatePos.haveMin0=item.haveMin0
						this.updatePos.haveMax0=item.haveMax0
						this.updatePos.sn=item.sn
						this.updatePos.suanF=item.suanF
						this.updatePos.radix=item.radix
						this.updatePos.haveRadix=item.haveRadix
						this.updatePos.paiXu=item.paiXu
						
						
						
					});
					this.dialogVisible=true;
					
					
				}
			},
			deleteSite(){this.$confirm('此操作将永久删除【' + this.multipleSelection.length + '】条记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let ids = '?';
                    this.multipleSelection.forEach(item => {
                        ids += 'ids=' + item.id + '&';
                    })
                    this.deleteRequest("/system/config/sysparam" + ids).then(resp => {
                        if (resp) {
                            this.initLoad();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
			initLoad(){
				this.$data.updatePos.limit=this.$data.pageSize;
				this.$data.updatePos.start=(this.$data.currentPage-1)*this.$data.pageSize;
				this.postRequest("/system/config/gsysparam",this.$data.updatePos).then(resp => {
				    //this.loading = false;
				    this.$data.totalD=resp.totalD;
					this.$data.tableData = resp.param;
				
				})
			},
			handleSelectionChange(val) {
				
				this.multipleSelection = val;
			},
		  arraySpanMethod({ row, column, rowIndex, columnIndex }) {
		    if (rowIndex % 2 === 0) {
		      if (columnIndex === 0) {
		        return [1, 2];
		      } else if (columnIndex === 1) {
		        return [0, 0];
		      }
		    }
		  },
				
		  objectSpanMethod({ row, column, rowIndex, columnIndex }) {
		    if (columnIndex === 0) {
		      if (rowIndex % 2 === 0) {
		        return {
		          rowspan: 2,
		          colspan: 1
		        };
		      } else {
		        return {
		          rowspan: 0,
		          colspan: 0
		        };
		      }
		    }
		  }
		}
	}
</script>

<style>
	.comStyle{
		margin-bottom: 8px
	}
	.updatePosInput-param {
	    width: 150px;
	    margin-right: 10px;
	}
	.comDia{
		font-size: 0;
		align-items: 2000px;
	}
	.comDia label{
		width: 80px;
		color: #99a9bf;
		
	}
	.el-table .success-row {
	    background: #f0f9eb;
	  }
	.input-boxp{
		width: 110px; 
		margin-right: -27px;
	}
	  
	   
	  
	 
	  
	  
	  
	  
</style>

